import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [roles, setRoles] = useState([]);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uniqueID, setUniqueID] = useState("");

  useEffect(() => {
    const loadUserFromToken = () => {
      try {
        const rawToken = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
        
        if (rawToken) {
          const decoded = jwtDecode(rawToken);
          setUserInfo(decoded.email);
          setRoles(decoded.roles || []);
          setToken(rawToken);
          setUniqueID(decoded.uniqueID || null);
        }
      } catch (err) {
        console.error("Invalid token", err);
        setUserInfo(null);
        setRoles([]);
        setToken(null);
        setUniqueID("");
      } finally {
        setLoading(false);
      }
    };

    loadUserFromToken();
  }, []);

  const refreshUserInfo = () => {
    setLoading(true);
    const loadUserFromToken = () => {
      try {
        const rawToken = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
        
        if (rawToken) {
          const decoded = jwtDecode(rawToken);
          setUserInfo(decoded.email);
          setRoles(decoded.roles || []);
          setToken(rawToken);
          setUniqueID(decoded.uniqueID);
        }
      } catch (err) {
        console.error("Invalid token", err);
        setUserInfo(null);
        setRoles([]);
        setToken(null);
        setUniqueID(null);
      } finally {
        setLoading(false);
      }
    };

    loadUserFromToken();
  };

  const value = {
    userInfo,
    roles,
    token,
    loading,
    refreshUserInfo,
    uniqueID,
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};
